var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSslIcon = function SvgSslIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.065 7.728a.607.607 0 0 0-.37-.49L16.54.935a.715.715 0 0 0-.578 0L1.804 7.237a.607.607 0 0 0-.369.49c-.018.19-.424 4.718 1.14 10.248.922 3.257 2.34 6.18 4.217 8.685 2.353 3.143 5.433 5.631 9.154 7.397a.71.71 0 0 0 .608 0c3.72-1.766 6.801-4.254 9.155-7.397 1.876-2.506 3.295-5.428 4.216-8.685 1.564-5.53 1.158-10.057 1.14-10.247Z",
    fill: "#60BC57",
    fillOpacity: 0.34
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.065 7.728a.607.607 0 0 0-.37-.49L16.54.935a.715.715 0 0 0-.578 0L1.804 7.237a.607.607 0 0 0-.369.49c-.018.19-.424 4.718 1.14 10.248.922 3.257 2.34 6.18 4.217 8.685 2.353 3.143 5.433 5.631 9.154 7.397a.71.71 0 0 0 .608 0c3.72-1.766 6.801-4.254 9.155-7.397 1.876-2.506 3.295-5.428 4.216-8.685 1.564-5.53 1.158-10.057 1.14-10.247Z",
    fill: "url(#ssl-icon_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.065 7.728a.607.607 0 0 0-.37-.49L16.54.935a.715.715 0 0 0-.578 0L1.804 7.237a.607.607 0 0 0-.369.49c-.018.19-.424 4.718 1.14 10.248.922 3.257 2.34 6.18 4.217 8.685 2.353 3.143 5.433 5.631 9.154 7.397a.71.71 0 0 0 .608 0c3.72-1.766 6.801-4.254 9.155-7.397 1.876-2.506 3.295-5.428 4.216-8.685 1.564-5.53 1.158-10.057 1.14-10.247Z",
    stroke: "#60BC57",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m16.363 2.832 13.11 5.7c.005.134.009.285.01.452l.002.495a29.251 29.251 0 0 1-1.14 7.776c-.864 2.984-2.19 5.664-3.951 7.96-2.087 2.723-4.79 4.902-8.034 6.492-3.244-1.59-5.947-3.77-8.034-6.491-1.76-2.297-3.087-4.977-3.951-7.962a29.23 29.23 0 0 1-1.14-7.758v-.495l13.128-6.169Z",
    stroke: "#fff",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m22.102 11.96-6.3 8.75-4.2-3.5",
    stroke: "#60BC57",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ssl-icon_svg__a",
    x1: 7.947,
    y1: 5.817,
    x2: 25.462,
    y2: 24.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F9"
  })))));
};
export default SvgSslIcon;